import { END_POINTS } from "../constants/url";
import emptySplitApi from "../utils/rtk";
import { BookingDetail } from "../types/General";

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const BookingApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getBooking: builder.query<
      CommonResponseType & {
        data: {
          data: any[];
          total: number;
        };
      },
      {
        from: number;
        size: number;
        status: string;
        type: string;
        search: string;
        userId?: string;
        ownerId?: string;
        country?:string
      }
    >({
      query: ({ from, size, status, type, search, userId, ownerId,country }) => ({
        url:
          `${END_POINTS.booking}?from=${from}&size=${size}&type=${type}` + (country?.length ? `&country=${country}` : "") +
          (status?.length ? `&status=${status}` : "") +
          (search?.length ? `&search=${search}` : "") +
          (userId?.length ? `&userId=${userId}` : "") +
          (ownerId?.length ? `&ownerId=${ownerId}` : ""),
        method: "GET",
      }),
    }),
    getBookingDetail: builder.query<
      CommonResponseType & { data: BookingDetail },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.booking}/${id}`,
        method: "GET",
      }),
    }),
    updateBooking: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.booking}/${id}`,
        method: "PUT",
        body,
      }),
    }),
     acceptRejectBooking: builder.mutation<
          CommonResponseType & { data: any },
          { body: any; id: string | undefined }
        >({
          query: ({ body, id }) => ({
            url: `${END_POINTS.statusChange}/${id}`,
            method: "PUT",
            body,
          }),
        }),
    // deleteBooking: builder.mutation<CommonResponseType, { id: string }>({
    //   query: ({ id }) => ({
    //     url: `${END_POINTS.booking}/${id}`,
    //     method: "DELETE",
    //   }),
    // }),
  }),
});

export const { useLazyGetBookingQuery, useLazyGetBookingDetailQuery,useUpdateBookingMutation,useAcceptRejectBookingMutation} =
  BookingApi;
